import AuthLayoutPage from './AuthLayoutPage';
import * as _paths from './paths';
import * as _viewPaths from './viewPaths';

export const paths = _paths;
export const viewPaths = _viewPaths;

export default AuthLayoutPage;
